import Vue from "vue";
import store from "@/store.js";
import { storeInfos } from "@/util/menuTable.js";
import language from "../languages/index";
import axios from "axios";
import localApi from "@/util/localApi.js";

let lang = localStorage.getItem("language") || store.state.language || "pt";

const splitByAc = window.location.href.split("/ac/");
let code = null;
if (splitByAc.length === 2) {
  code = splitByAc[1];
  // remove query string
  code = code.split("?")[0];
}

const getInfoTable = (isExist, newLang = false) => {
  let domain = Vue.prototype.$domain();
  let alreadyExist = isExist;
  const headers = {
    "Content-Type": "multipart/form-data",
    "x-api-key": "02ff96c8f50ce6a488812146d448a04b2e2358dd45d0dbb59824",
    language: newLang || lang,
  };
  storeInfos(); // Store.state.infoSportsMarket (Customizado);
  return new Promise((resolve) => {
    let infoTableEndpoint = "";

    if (localApi()) {
      infoTableEndpoint = localApi() + "/main/infoTable";
    } else if (domain == "sysbet") {
      infoTableEndpoint = "https://apidev.sga.bet/main/infoTable";
    } else if (domain == "homolog") {
      infoTableEndpoint = "https://apiv2dev.sga.bet/main/infoTable";
    } else {
      infoTableEndpoint = "https://v2.envrelease.com/main/infoTable";
    }

    axios
      .post(
        infoTableEndpoint,
        Vue.prototype.$formdata({
          domain,
        }),
        { headers }
      )
      .then((resp) => {
        store.commit("setMarkets", resp.data.markets);
        store.commit("setResults", resp.data.outcomes);
        store.commit("setSports", resp.data.sports);
        store.commit("setOperators", resp.data.operator);
        store.commit("setPaymentMethods", resp.data.operator.payment_methods);
        // verification options

        if (code) {
          localStorage.setItem("affiliateCode", code);
          localStorage.setItem("forceOpenRegister", true);
        }

        const {
          verify_bank,
          document_verification,
          phone_verification,
        } = resp.data.operator;

        const verificationSteps = [];

        if (document_verification == "1") {
          verificationSteps.push({
            name: language[lang].verification.document.name,
            nameId: "document_verification",
          });
        }

        if (verify_bank == "1") {
          verificationSteps.push({
            name: language[lang].verification.bank.name,
            nameId: "bank_verification",
          });
        }

        if (Vue.prototype.$isCreditOnline()) {
          verificationSteps.push({
            name: language[lang].verification.email.name,
            nameId: "email_verification",
          });
        }

        if (phone_verification == "1") {
          verificationSteps.push({
            name: language[lang].verification.phone.name,
            nameId: "phone_verification",
          });
        }

        store.commit("setVerificationSteps", verificationSteps);

        if (!alreadyExist) {
          const result = "200";
          resolve(result);
        } else {
          // console.log(language[lang].updateSystem);
          // const msg = language[lang].updateSystem;
          // const color = "black";
          // store.commit("setNotification", {
          //   msg,
          //   color,
          // });
          resolve("200");
        }
      })
      .catch((err) => {
        store.commit("setFeedback", {
          title: `Erro ${err.response.status}. ${err.response.data.messages}`,
          msg: language[lang].somethingDidntWork,
          type: "warning",
          persistent: true,
          // action: 'refresh'
        });
      });
  });
};
export default getInfoTable;
